var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Layout"},[_c('web-nav',{ref:"webNav"}),_c('div',{staticClass:"main-container",style:({minHeight: _vm.browserHeight-250-80+'px'})},[_c('router-view')],1),_c('bottom',{ref:"bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }